<input [formControl]="formControl" class="" [matAutocomplete]="auto">
<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
  @for (person of searchService.people$ | async; track person) {
    <mat-option [value]="person">{{person.name}}</mat-option>
  }
</mat-autocomplete>
